// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dtm-container>.header[data-v-f9632424]{font-size:2.5em;position:relative;display:block;line-height:1.2em;padding:25px 60px 10px 10px}@media(max-width: 768px){.dtm-container>.header[data-v-f9632424]{font-size:1.8em;padding:15px 30px 7px 12px}html.native .dtm-container>.header[data-v-f9632424]{padding:25px 30px 7px 18px}}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
